<div *ngIf="open" class="fixed inset-0 z-[60] flex items-end sm:items-center justify-center bg-gray-900/60 backdrop-blur-sm sm:p-4">
  <div class="bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl w-full max-w-3xl max-h-[92dvh] sm:max-h-[92vh] flex flex-col">

    <div class="sm:hidden mx-auto mt-3 h-1 w-10 rounded-full bg-gray-300 flex-shrink-0"></div>
    <!-- Header -->
    <div class="flex items-center justify-between px-4 sm:px-6 py-4 border-b border-gray-200">
      <div>
        <h2 class="text-lg font-semibold text-gray-900">Collect payments — bulk</h2>
        <p class="text-xs text-gray-500 mt-0.5">
          {{ eligibleCount() }} member(s) eligible · Total <span class="font-semibold text-gray-700">Rs. {{ totalAmount() | number:'1.2-2' }}</span>
        </p>
      </div>
      <button (click)="close()" [disabled]="isSaving()"
              class="text-gray-400 hover:text-gray-600 disabled:opacity-50">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-y-auto overscroll-contain p-4 sm:p-6 space-y-4">

      @if (errorMessage()) {
        <div class="bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded-lg text-sm">
          {{ errorMessage() }}
        </div>
      }

      <!-- Period + method strip -->
      <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Month</label>
          <select [(ngModel)]="month"
                  class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option *ngFor="let m of months" [ngValue]="m.value">{{ m.name }}</option>
          </select>
        </div>
        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Year</label>
          <select [(ngModel)]="year"
                  class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
          </select>
        </div>
        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Method</label>
          <select [ngModel]="paymentMethod()" (ngModelChange)="paymentMethod.set($event)"
                  class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value="Cash">Cash</option>
            <option value="Bank">Bank Transfer</option>
            <option value="Online">Online</option>
            <option value="Cheque">Cheque</option>
          </select>
        </div>
        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Reference</label>
          <input type="text" [ngModel]="reference()" (ngModelChange)="reference.set($event)"
                 placeholder="Optional"
                 class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"/>
        </div>
      </div>

      <!-- Rows (mobile cards) -->
      <div class="md:hidden border border-gray-200 rounded-xl overflow-hidden divide-y divide-gray-100">
        @for (r of rows(); track r.memberId) {
          <div class="p-3 space-y-2">
            <div class="flex items-start justify-between gap-2">
              <div class="min-w-0 flex-1">
                <div class="font-medium text-gray-900 truncate">{{ r.fullName }}</div>
                <div class="text-xs text-gray-500 mt-0.5">Expected Rs. {{ r.expected | number:'1.2-2' }}</div>
                @if (r.totalPaid > 0 && r.shortfall > 0) {
                  <span class="inline-flex items-center gap-1 text-xs text-amber-700 mt-0.5">
                    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 8v4m0 4h.01M12 2a10 10 0 100 20 10 10 0 000-20z"/></svg>
                    Paid Rs. {{ r.totalPaid | number:'1.2-2' }} · shortfall Rs. {{ r.shortfall | number:'1.2-2' }}
                  </span>
                } @else if (r.totalPaid > 0) {
                  <span class="inline-flex items-center gap-1 text-xs text-green-700 mt-0.5">
                    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/></svg>
                    Paid Rs. {{ r.totalPaid | number:'1.2-2' }} for this period
                  </span>
                }
              </div>
              <button type="button" (click)="removeRow(r.memberId)" [disabled]="isSaving()"
                      class="tap-target inline-flex items-center justify-center p-2 -m-1 text-gray-300 hover:text-red-600 disabled:opacity-30"
                      title="Remove from this batch">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
              </button>
            </div>
            <div class="flex items-center gap-2">
              <label class="text-xs font-medium text-gray-700 flex-shrink-0">Amount (Rs.)</label>
              <input type="number" min="0" step="0.01"
                     [ngModel]="r.amount"
                     (ngModelChange)="setAmount(r.memberId, $event)"
                     class="flex-1 text-right border border-gray-300 rounded-lg px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"/>
            </div>
          </div>
        }
        @if (rows().length === 0) {
          <div class="text-center text-gray-400 py-6 text-sm">No members in this batch.</div>
        }
      </div>

      <!-- Rows (table, md+) -->
      <div class="hidden md:block border border-gray-200 rounded-xl overflow-hidden">
        <table class="w-full text-sm">
          <thead class="bg-gray-50 border-b border-gray-100 text-xs font-semibold text-gray-500 uppercase tracking-wider">
            <tr>
              <th class="text-left px-4 py-2.5">Member</th>
              <th class="text-right px-4 py-2.5 w-32">Expected</th>
              <th class="text-right px-4 py-2.5 w-44">Amount (Rs.)</th>
              <th class="text-right px-3 py-2.5 w-10"></th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200">
            @for (r of rows(); track r.memberId) {
              <tr class="odd:bg-white even:bg-gray-100 hover:bg-blue-100 transition-colors">
                <td class="px-4 py-2.5">
                  <div class="font-medium text-gray-900">{{ r.fullName }}</div>
                  @if (r.totalPaid > 0 && r.shortfall > 0) {
                    <span class="inline-flex items-center gap-1 text-xs text-amber-700 mt-0.5">
                      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 8v4m0 4h.01M12 2a10 10 0 100 20 10 10 0 000-20z"/></svg>
                      Paid Rs. {{ r.totalPaid | number:'1.2-2' }} · shortfall Rs. {{ r.shortfall | number:'1.2-2' }}
                    </span>
                  } @else if (r.totalPaid > 0) {
                    <span class="inline-flex items-center gap-1 text-xs text-green-700 mt-0.5">
                      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/></svg>
                      Paid Rs. {{ r.totalPaid | number:'1.2-2' }} for this period
                    </span>
                  }
                </td>
                <td class="px-4 py-2.5 text-right text-gray-500">Rs. {{ r.expected | number:'1.2-2' }}</td>
                <td class="px-4 py-2.5 text-right">
                  <input type="number" min="0" step="0.01"
                         [ngModel]="r.amount"
                         (ngModelChange)="setAmount(r.memberId, $event)"
                         class="w-full text-right border border-gray-300 rounded-lg px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"/>
                </td>
                <td class="px-3 py-2.5 text-right">
                  <button type="button" (click)="removeRow(r.memberId)" [disabled]="isSaving()"
                          class="text-gray-300 hover:text-red-600 disabled:opacity-30"
                          title="Remove from this batch">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                    </svg>
                  </button>
                </td>
              </tr>
            }
            @if (rows().length === 0) {
              <tr><td colspan="4" class="text-center text-gray-400 py-6 text-sm">No members in this batch.</td></tr>
            }
          </tbody>
        </table>
      </div>

    </div>

    <!-- Footer -->
    <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-3 px-4 sm:px-6 py-4 pb-[max(1rem,env(safe-area-inset-bottom))] sm:pb-4 border-t border-gray-200 bg-gray-50">
      <div class="text-sm text-gray-700">
        Total to collect: <span class="font-bold text-gray-900">Rs. {{ totalAmount() | number:'1.2-2' }}</span>
      </div>
      <div class="flex flex-col-reverse sm:flex-row sm:items-center gap-2 sm:gap-3">
        <button type="button" (click)="close()" [disabled]="isSaving()"
                class="w-full sm:w-auto max-md:tap-target px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-lg disabled:opacity-50">
          Cancel
        </button>
        <button type="button" (click)="submit()" [disabled]="isSaving() || eligibleCount() === 0"
                class="w-full sm:w-auto max-md:tap-target inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-sm disabled:opacity-50">
          <app-spinner *ngIf="isSaving()" size="xs" colour="white"></app-spinner>
          {{ isSaving() ? 'Recording…' : 'Record ' + eligibleCount() + ' payment(s)' }}
        </button>
      </div>
    </div>

  </div>
</div>
